import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { SIDE_BAR_WIDTH } from '@/layouts/MainLayout/utils/constants';
import { Theme } from '@mui/material/styles';

export const StyledWrapper = styled.div<{ isDesktop: boolean; theme?: Theme }>`
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ isDesktop }) => (isDesktop ? `calc(100% - ${SIDE_BAR_WIDTH})` : '100%')};
  height: 100%;
  z-index: 1;
  background: ${({ theme }) => theme.palette.customSecondary.neutral.black};
`;

export const StyledTypography = styled(Typography)<{ theme?: Theme }>`
  max-width: 700px;
  ${({ theme }) => ({ ...theme.typography.custom.AgioH1 })};
  text-align: center;
  color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
`;
